
scittle.clara_rules.init();